import {
	getViemClients,
} from "@bracket/contractor-next";

import {
	getContractWithABI,
	isAddress,
	isBlockHash,
	isWEIString,
	type ValidChainId,
	type BlockHash,
	type WEIString,
} from "@bracket/chainography";

import type {
	Config,
} from "@wagmi/core";




export declare type UpdateNavProps = {
	vault: string;
	newNav: WEIString;
	managerPerformanceFee: WEIString;
	managerTvlFee: WEIString;
	brktTvlFee: WEIString;
	chainId?: ValidChainId;
	config?: Config;
};


/**
 * Update the NAV for a given vault, incrementing the epoch by one, and allowing adjusted values.
 * @param {Address} vault the vault address
 * @param {bigint|number|WEIString} newNav the value either in brkt, or a bigint 1e18 value.
 * @param {bigint|number|WEIString} managerTvlFee the value either in brkt, or a bigint 1e18 value.
 * @param {bigint|number|WEIString} brktTvlFee the value either in brkt, or a bigint 1e18 value.
 * @param {bigint|number|WEIString} managerPerformanceFee the value either in brkt, or a bigint 1e18 value.

* @returns {bigint} the numer of assets in its bigint format
 */
export const updateNav = async ({
	newNav,
	managerPerformanceFee,
	managerTvlFee,
	brktTvlFee,
	vault,
	chainId = 1,
	config,
}: UpdateNavProps): Promise<BlockHash> => {

	try {

		if(chainId !== 1)
			throw new Error("updateNav supports only chain 1");

		if(!isAddress(vault))
			throw new Error("invalid vault address");

		if(!isWEIString(newNav)) throw new Error("newNav not a WEIString");
		if(!isWEIString(managerPerformanceFee)) throw new Error("managerPerformanceFee not a WEIString");
		if(!isWEIString(managerTvlFee)) throw new Error("managerTvlFee not a WEIString");
		if(!isWEIString(brktTvlFee)) throw new Error("brktTvlFee not a WEIString");

		const bNewNav = BigInt(newNav);
		const bManagerTvlFee = BigInt(managerTvlFee);
		const bManagerPerformanceFee = BigInt(managerPerformanceFee);
		const bBrktTvlFee = BigInt(brktTvlFee);

		const [
			vclient,
			wclient,
		] = await getViemClients({ chainId, config, });
		
		const [
			_,
			abi,
		] = getContractWithABI("BracketVault");

		const {
			request,
			result, // result is undefined...
		} = await vclient.simulateContract({
			address: vault,
			abi,
			functionName: "updateNav",
			args: [
				bNewNav,
				bManagerPerformanceFee,
				bManagerTvlFee,
				bBrktTvlFee
			],
			account: wclient.account,
		});

		if(request) {
			const hash = await wclient.writeContract(request);
			if(isBlockHash(hash)) {
				return hash;
			}
			throw new Error("contract did not return a block hash");
		}

		throw new Error("contract simulated failed to simulate");

	} catch (err) {
		window.err = err;
		console.log("ERRRRRRRRRRRRRRRRRRRRRRRRR", err);

		console.log([
			"Nav update has failed for the following reason:",
			err.message,
			""
		].join("\n"));
		throw new Error(`@bracket/chainography/bracketVault:updateNav failed - ${err.message}`);
	}

};
